(function (window, $) {
  // Constants identifying goal types
  var CURRENT_GOAL = 'your';
  var NEXT_GOAL = 'next';
  var NEW_GOAL = 'new';
  var PREVIOUS_GOAL = 'prev';

  var JOIN = 'join';
  var TOP_MESSAGE_TIMEOUT = 10000;

  /**
   * Do nothing
   *
   * @returns {undefined}
   */
  function noop() {}

  // soulcup/analytics.js might have not been loaded.
  // Initialization is deferred to document ready
  var analytics = {
    track: noop,
    update: noop
  };

  /**
   * Show top message
   *
   * @param {string} type join|leave
   * @returns {undefined}
   */
  function showTopMessage(type) {
    var joined = '.soulcup-top-message__joined';
    var left = '.soulcup-top-message__left';
    var open = 'soulcup-top-message--open';

    var $message = $('.soulcup-top-message');
    var $closeButton = $message.find('.soulcup-top-message__close');

    var closeTopMessage = function () {
      $message.find('.soulcup-top-message__content').slideUp(500, function () {
        $message.removeClass(open);
        $closeButton.off('click');
      });
    };

    $closeButton.one('click', function (e) {
      e.preventDefault();
      closeTopMessage();
    });

    var selectors = type === 'leave' ?
      [left, joined] :
      [joined, left];

    $message.find(selectors[1]).hide();
    $message.find(selectors[0]).show();
    $message.addClass(open);

    $message.find('.soulcup-top-message__content').slideDown(250);

    setTimeout(closeTopMessage, TOP_MESSAGE_TIMEOUT);
  }

  /**
   * Show default state for Leave Team card
   *
   * @returns {undefined}
   */
  function showLeaveTeamDefault() {
    var $container = $('.soulcup-dashboard__team-info');
    $container.find('.soulcup-dashboard__team-leave-confirmation').hide();
    $container.find('.soulcup-dashboard__team-summary').show();
  }

  /**
   * Toggle the team card based on the team data
   *
   * @param {Object} team team object
   * @returns {undefined}
   */
  function toggleTeamCard(team) {
    var $container = $('.soulcup-dashboard__team-info');
    if (!team) {
      $container.removeClass('soulcup-dashboard__team-info--has-team');
      $container.addClass('soulcup-dashboard__team-info--no-team');
      $container.find('input[name="team_code"]').val('');
      return;
    }
    $container.find('input[name="team_id"]').val(team.id);
    $container.find('.soulcup-dashboard__team-summary-name, .soulcup-dashboard__team-leave-team-name').text(team.name);
    $container.find('.soulcup-dashboard__team-summary-total-riders').text(team.total_riders);
    showLeaveTeamDefault();
    $container.removeClass('soulcup-dashboard__team-info--no-team');
    $container.addClass('soulcup-dashboard__team-info--has-team');
  }

  /**
   * Try to join the team by making AJAX request
   *
   * @param {Object} $form join team form
   * @param {Object} $codeInput team code input
   * @returns {undefined}
   */
  function tryToJoinTeam($form, $codeInput) {
    $form.clearFormErrors();
    $form
      .find('.soulcup-dashboard__join-team-form-input--error, .soulcup-dashboard__join-team-form-label--error')
      .removeClass('soulcup-dashboard__join-team-form-input--error soulcup-dashboard__join-team-form-label--error');
    $form.find('.soulcup-dashboard__join-team-form-error').hide();

    $form.ajaxSubmit({
      dataType: 'json',
      success: function (response) {
        $form.updateCsrfToken();
        toggleTeamCard(response.team);

        var eventData = {
          Response: 'Success',
          Location: 'Form'
        };
        analytics.update({
          'Team ID': response.team.id,
          'Team Status': 'Team'
        });
        analytics.track('Get Join Team Response', 'Dashboard', eventData);
        showTopMessage(JOIN);
      },
      error: function (response, status) {
        $form.updateCsrfToken();
        var json = response.responseJSON;
        var errorMessage = json && json.error;
        showJoinTeamError($form, $codeInput, errorMessage);

        var eventData = {
          Response: 'Submit error - status: ' + status + ', form error: ' + errorMessage,
          Location: 'Form'
        };
        analytics.track('Get Join Team Response', 'Dashboard', eventData);
      }
    });
  }

  /**
   * Try to leave the team by making AJAX request
   *
   * @param {Object} $form leave team form
   * @returns {undefined}
   */
  function tryToLeaveTeam($form) {
    $form.ajaxSubmit({
      dataType: 'json',
      success: function () {
        $form.updateCsrfToken();
        var eventData = {
          Response: 'Success',
          Location: 'Form'
        };
        analytics.update({
          'Team Status': 'Unjoined',
          'Team ID': ''
        });
        analytics.track('Get Leave Team Response', 'Dashboard', eventData);

        // Allow some time for tracking
        setTimeout(function () {
          location.reload();
        }, 500);
      },
      error: function (response, status) {
        $form.updateCsrfToken();
        var json = response.responseJSON;
        var errorMessage = json && json.error;
        confirmation(null, errorMessage);

        var eventData = {
          Response: 'Submit error - status: ' + status + ', form error: ' + errorMessage,
          Location: 'Form'
        };
        analytics.track('Get Leave Team Response', 'Dashboard', eventData);
      }
    });
  }

  /**
   * Show validation error
   *
   * @param {Object} $form join team form
   * @param {Object} $codeInput team code input
   * @param {string} message error message
   * @returns {undefined}
   */
  function showJoinTeamError($form, $codeInput, message) {
    var $formError = $form.find('.soulcup-dashboard__join-team-form-error');
    var $label = $form.find('label[for=' + $codeInput.attr('id') + ']');

    $codeInput.addClass('soulcup-dashboard__join-team-form-input--error');
    $label.addClass('soulcup-dashboard__join-team-form-label--error');

    $formError.text(message);
    $formError.show();
  }

  /**
   * Initialize the join team card
   *
   * @param {Object} $dashboard dashboard
   * @returns {undefined}
   */
  function initJoinTeamCard($dashboard) {
    var $form = $dashboard.find('.soulcup-dashboard__team-info__join-team');
    var $codeInput = $form.find('input');

    $form.submit(function (e) {
      e.preventDefault();
      var code = $codeInput.val();

      analytics.update({
        'Enrollment Status': 'Enrolled',
        'Team Status': 'Solo'
      });
      analytics.track('Click Join Team', 'Dashboard', { Location: 'Form' });

      if (!code.match(/[a-zA-Z]{3}\d{3}/)) {
        showJoinTeamError($form, $codeInput, 'The code you entered is incorrect.');
        return;
      }

      tryToJoinTeam($form, $codeInput);
    });
  }

  /**
   * Create the modal attached to the given selector
   *
   * @param {string} selector modal container selector
   * @param {Object} initialState initial state
   * @returns {Object} modal object
   */
  function createModal(selector, initialState) {
    var $modal = $(selector);

    var $goalType = $modal.find('.progress-goal-modal__goal-type');
    var $totalRides = $modal.find('.progress-goal-modal__total-rides');

    var $closeButton = $modal.find('.progress-goal-modal__dialog-close');
    var $doneButton = $modal.find('.progress-goal-modal__button-done');
    var $changeButton = $modal.find('.progress-goal-modal__button-change');

    var $scoredMessage = $modal.find('.progress-goal-modal__scored-message');
    var $objectiveMessage = $modal.find('.progress-goal-modal__objective-message');
    var $currentObjectiveMessage = $modal.find('.progress-goal-modal__current-objective-message');

    var goals = (initialState.availableGoals || []).reduce(function (acc, goal) {
      acc[goal] = $modal.find('.' + goal + '-rides-goal');
      return acc;
    }, {});

    var state = Object.assign({
      campaignId: null,
      classesTaken: null,
      clickedGoal: null,
      clickedGoalType: '',
      currentGoal: null,
      isOpen: false,
      onGoalChangeSuccess: noop,
      onGoalChangeFail: noop
    }, initialState);

    $closeButton.click(function () {
      update({ isOpen: false });
    });
    $doneButton.click(function () {
      update({ isOpen: false });
    });
    $changeButton.click(function () {
      $.ajax({
        url: '/turn-it-up/me/updategoal/',
        data: {
          'campaignId': state.campaignId,
          'goal': state.clickedGoal
        },
        type: 'put',
        dataType: 'json',
        success: function () {
          state.onGoalChangeSuccess(state.clickedGoal);
        },
        error: function () {
          state.onGoalChangeFail(state.clickedGoal);
        },
        complete: function () {
          update({ isOpen: false });
        }
      });
    });

    /**
     * Show the section matching the goal and hide others
     *
     * @param {number} goalNumber goal to show
     * @returns {undefined}
     */
    function showGoal(goalNumber) {
      Object.keys(goals).forEach(function (goal) {
        goals[goal].hide();
      });

      goals[goalNumber].show();
    }

    /**
     * Update the action buttons
     *
     * @param {string} goalType type of selected goal
     * @returns {undefined}
     */
    function updateActionButtons(goalType) {
      if (goalType === CURRENT_GOAL) {
        $changeButton.hide();
        $doneButton.show();
        return;
      }

      $changeButton.show();
      $doneButton.hide();
    }

    /**
     * Update the header to align with clicked goal
     *
     * @param {string} goalType type of selected goal
     * @param {number} goalNumber new goal
     * @returns {undefined}
     */
    function updateHeader(goalType, goalNumber) {
      var typeText = goalType[0].toUpperCase() + goalType.slice(1) + ' Goal';
      $goalType.text(typeText);
      $totalRides.text(goalNumber);
    }

    /**
     * Update the description to align with clicked goal
     *
     * @param {string} goalType type of selected goal
     * @param {number} classesTaken total classes the rider has taken
     * @param {number} goalNumber clicked goal
     * @returns {undefined}
     */
    function updateDescription(goalType, classesTaken, goalNumber) {
      $currentObjectiveMessage.hide();
      $objectiveMessage.hide();
      $scoredMessage.hide();
      if (classesTaken >= goalNumber) {
        $scoredMessage.show();
        return;
      }

      if (goalType === CURRENT_GOAL) {
        var missingRides = goalNumber - classesTaken;
        $currentObjectiveMessage.find('.progress-goal-modal__remaining-number-of-rides').text(missingRides + ' more rides');
        $currentObjectiveMessage.show();
        return;
      }

      $objectiveMessage.find('.progress-goal-modal__number-of-rides').text(goalNumber + ' rides');
      $objectiveMessage.show();
    }

    /**
     * Updates the modal UI to match the state
     *
     * @param {Object} newState state to update elements
     * @param {boolean} newState.isOpen modal open/close flag
     * @param {number} newState.clickedGoal clicked goal
     * @returns {undefined}
     */
    function update(newState) {
      state = Object.assign(state, newState);

      if (!state.isOpen) {
        $modal.hide();
        return;
      }

      showGoal(state.clickedGoal);
      updateActionButtons(state.clickedGoalType);
      updateHeader(state.clickedGoalType, state.clickedGoal);
      updateDescription(state.clickedGoalType, state.classesTaken, state.clickedGoal);
      $modal.show();
    }

    return {
      update: update
    };
  }

  /**
   * Get what type of goal the clicked goal element represents
   *
   * @param {Object} $element clicked goal element
   * @param {number} clickedGoal goal corresponding to clicked element
   * @param {number} currentGoal currently rider goal
   * @returns {string} goal type
   */
  function getGoalTypeFromElement($element, clickedGoal, currentGoal) {
    if ($element.hasClass('soulcup-progress-goal--your-goal')) {
      return CURRENT_GOAL;
    }

    if ($element.hasClass('soulcup-progress-goal--next-goal')) {
      return NEXT_GOAL;
    }

    if (clickedGoal > currentGoal) {
      return NEW_GOAL;
    }

    return PREVIOUS_GOAL;
  }

  /**
   * Update the progress timeline UI based on the goal
   *
   * @param {Object} $dashboard dashboard element
   * @param {number} goal goal to use for update
   * @returns {undefined}
   */
  function updateTimelineUI($dashboard, goal) {
    var $goals = $dashboard.find('.soulcup-progress-goal');

    $goals.removeClass('soulcup-progress-goal--your-goal soulcup-progress-goal--next-goal');

    var $selected = $goals.filter('[data-ride-number="' + goal + '"]');
    $selected.addClass('soulcup-progress-goal--your-goal');
    $selected.nextAll('.soulcup-progress-goal').first().addClass('soulcup-progress-goal--next-goal');
  }

  /**
   * Update the dashboard UI based on the goal
   *
   * @param {Object} $dashboard dashboard element
   * @param {number} goal goal to use for update
   * @returns {undefined}
   */
  function updateDashboardUI($dashboard, goal) {
    // TODO: Update here to update ride count over total whenever that is implemented
    var $goal = $dashboard.find('.soulcup-dashboard__rider-goal');
    $goal.text(goal);
  }

  /**
   * Handle successful goal change in backend and align UI with selection
   *
   * @param {Object} $dashboard dashboard element
   * @param {number} goal selected and changed goal
   * @returns {undefined}
   */
  function onGoalChangeSuccess($dashboard, goal) {
    updateTimelineUI($dashboard, goal);
    updateDashboardUI($dashboard, goal);

    // Send mparticle event for goal change
    var eventData = {
      'Current Goal': parseInt($dashboard.data('rider-goal'), 10),
      'Updated Goal': goal
    };
    analytics.track('Change Goal', 'Progress Modal', eventData);

    $dashboard.data('rider-goal', goal);
    confirmation(null, 'Your goal has been updated.');
  }

  /**
   * Handle failure of goal change in backend, notifying the user
   *
   * @returns {undefined}
   */
  function onGoalChangeFail() {
    confirmation(null, 'Could not fulfill this request.');
  }

  /**
   * Initialize the ride goal UI and events
   *
   * @returns {undefined}
   */
  function initRideGoal() {
    var $dashboard = $('.soulcup-dashboard');
    var $goals = $('.soulcup-progress-goal');
    var campaignId = parseInt($dashboard.data('campaign-id'), 10);
    var availableGoals = $dashboard.data('available-goals') || [];

    var modal = createModal('.progress-goal-modal', {
      availableGoals: availableGoals,
      campaignId: campaignId,
      onGoalChangeSuccess: onGoalChangeSuccess.bind(null, $dashboard),
      onGoalChangeFail: onGoalChangeFail.bind($dashboard)
    });

    $goals.each(function () {
      var $goal = $(this);
      $goal.click(function (event) {
        event.preventDefault();
        var $this = $(this);
        var currentGoal = parseInt($dashboard.data('rider-goal'), 10);
        var classesTaken = parseInt($dashboard.data('classes-taken'), 10);
        var clickedGoal = parseInt($this.find('.ride-number').text(), 10);
        var goalType = getGoalTypeFromElement($this, clickedGoal, currentGoal);

        var eventData = {'Goal Viewed': this.goal};
        analytics.track('View Goal', 'Progress', eventData);

        modal.update({
          classesTaken: classesTaken,
          clickedGoal: clickedGoal,
          clickedGoalType: goalType,
          currentGoal: currentGoal,
          isOpen: true
        });
      });
    });

    $('.view-all-rides').click(function () {
      analytics.track('View All Rides', 'Dashboard');
    });

    $('.go-to-schedule').click(function () {
      analytics.track('Go to Schedule', 'Dashboard');
    });
  }

  /**
   * Ask for confirmation prior to taking an action
   *
   * @param {Object} $form original form
   * @param {Object} $confirmation confirmation element
   * @param {Function} onConfirm action to execute when confirmed
   * @returns {undefined}
   */
  function askForConfirmation($form, $confirmation, onConfirm) {
    $confirmation
      .find('.soulcup-dashboard__team-leave-cancel-button')
      .one('click', function (e) {
        e.preventDefault();
        showLeaveTeamDefault();
      });

    $confirmation
      .find('.soulcup-dashboard__team-leave-confirm-button')
      .one('click', function (e) {
        e.preventDefault();
        onConfirm();
      });

    $form.hide();
    $confirmation.show();
  }

  /**
   * Initialize the team summary card and leave button
   *
   * @param {Object} $dashboard dashboard
   * @returns {undefined}
   */
  function initTeamSummaryCard($dashboard) {
    var $form = $dashboard.find('.soulcup-dashboard__team-summary');
    var $confirmation = $dashboard.find('.soulcup-dashboard__team-leave-confirmation');
    var $teamId = $form.find('input[name="team_id"]');

    $form.submit(function (e) {
      e.preventDefault();
      var teamId = $teamId.val();
      analytics.update({
        'Enrollment Status': 'Enrolled',
        'Team Status': 'Team',
        'Team ID': teamId
      });
      analytics.track('Click Leave Team', 'Dashboard', { Location: 'Form' });

      if (!teamId) {
        confirmation(null, 'There was an unexpected error. Please refresh and try again.');
        return;
      }

      askForConfirmation($form, $confirmation, function () {
        tryToLeaveTeam($form);
      });
    });
  }

  $(document).ready(function onReady() {
    var $dashboard = $('.soulcup-dashboard');
    if (!$dashboard.length) {
      return;
    }

    var $teamId = $dashboard.find('input[name="team_id"]');
    var teamStatus = !!$teamId.length;

    // Initialize analytics after ready
    analytics = window.SC.soulcupAnalytics.createAnalyticsManager('Dashboard', {
      'Enrollment Status': 'Enrolled',
      'Team Status': teamStatus ? 'Team' : 'Solo',
      'Team ID': $teamId.val() || ''
    });
    analytics.track('View Screen', 'Dashboard');

    initRideGoal();
    initJoinTeamCard($dashboard);
    initTeamSummaryCard($dashboard);
  });
})(window, jQuery);
